// extracted by mini-css-extract-plugin
export default {"video_container":"VideoItem_video_container__qTwXq","youtube_player":"VideoItem_youtube_player__cN2ui","loaded":"VideoItem_loaded__m22Ma"};